export const BASE = {
  name: 'overview',
  path: '/sites/:siteId/overview',
};

export const SETUP = {
  name: 'setup',
  path: '/sites/:siteId/setup',
};
